import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  action: "",
  alert_class: "success",
  alert_icon: "fa-exclamation-circle",
  alert_txt: "",
};

const alertSlice = createSlice({
  name: "alert",
  initialState,
  reducers: {
    showAlert(state, action) {
      state.action = action.payload.action;
      state.alert_txt = action.payload.alert_txt;
      state.alert_icon = action.payload.alert_icon;
      state.alert_class = action.payload.alert_class;
    },
  },
});
export const alertAction = alertSlice.actions;
export default alertSlice.reducer;
